












helpers = require('../../helpers.coffee')

exports.default =
  props: ['variables']

  methods:
    addVariable: (variable) ->
      @$emit('add-variable',{variable, @attribute})
      IntercomCtrl.trackEvent(this.$t('template.label.templateVariableUsing', { name: variable.name }))




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/templates/variables_dropdown.vue